<template>
    <div class="container">
        <b-modal
          :model-value="modAsociaMenu"
          :no-close-on-backdrop="true"
          hide-footer
          hide-header-close
          centered
          size="xl"
          dialog-class="modal-asocia-menu-wide"
          :title="nombreRol || ''"
          header-class="reset-modal-header"
          title-class="reset-modal-title"
          body-class="reset-modal-body"
          class="reset-password-dialog"
        >
            <div class="uniform-modal-body uniform-modal-body--wide">
                <div class="password-policy-box mb-4">
                    <div class="password-policy-title">{{ labels.infoTitle }}</div>
                    <div class="password-policy-subtitle">{{ labels.infoText }}</div>
                </div>
                <div class="menu-association-layout">
                    <div class="menu-sidebar">
                        <div class="menu-sidebar-title">{{ labels.menuListTitle }}</div>
                        <b-button
                          v-for="menu in listadoMenus"
                          :key="menu.id"
                          @click="listaSubmenu(menu?.id)"
                          class="menu-sidebar-item"
                          :class="{ active: selectedMenuId === menu.id }"
                        >
                          {{ menu?.nombre }}
                        </b-button>
                    </div>
                    <div class="menu-content">
                        <div class="menu-content-title">{{ nombreMenu?.nombre || labels.selectMenuHint }}</div>
                        <div class="submenu-box" v-if="listadoSubMenus?.length > 0">
                            <div
                              v-for="submenu in listadoSubMenus"
                              :key="submenu?.id"
                              class="submenu-row d-flex align-items-center justify-content-between"
                            >
                                <div class="submenu-name">{{ submenu?.nombre }}</div>
                                <b-form-checkbox
                                  v-model="submenuSelect"
                                  :value="submenu?.id"
                                  switch
                                  class="submenu-switch mb-0"
                                  @change="asociaSubMenu(submenu?.id)"
                                >
                                  {{ submenuSelect.includes(submenu?.id) ? labels.active : labels.inactive }}
                                </b-form-checkbox>
                            </div>
                        </div>
                        <div class="no-submenus" v-if="showRow">
                            {{ labels.noRow }}
                        </div>
                    </div>
                </div>
                <div class="reset-dialog-actions d-flex justify-content-end mt-4 uniform-actions-wrap">
                    <b-button class="reset-btn-secondary" @click="cierraModal">{{ labels.close }}</b-button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import Submenu from '../../services/SubMenu'; 
import Menu from '../../services/Menu'; 
import Roles from '../../services/Roles'; 
import RoleMenu from '../../services/RoleMenu'; 

export default {
    name: "ModalAsociaMenu",
    props: ['modAsociaMenu', 'IdRol'],
    data: () => ({
        listadoMenus: [],
        listadoSubMenus: [],
        listadoSubMenusAsoc: [],
        submenuSelect: [],
        nombreRol: "",
        nombreMenu: "",
        menuSelected: "",
        selectedMenuId: null,
        showRow: false,
    }),
    computed: {
        labels() {
            if (this.$store.state._language == "es-ES") { 
                return {
                    save: "Guardar",
                    close: "Cerrar",
                    noRow: "No hay submenús disponibles",
                    active: "Activo",
                    inactive: "Inactivo",
                    infoTitle: "Asociación de menús",
                    infoText: "Selecciona un menú de la barra lateral y activa o desactiva sus submenús.",
                    menuListTitle: "Menús",
                    selectMenuHint: "Selecciona un menú"
                }
            } else {
                return {
                    save: "Save",
                    close: "Close",
                    noRow: "There are no submenus available",
                    active: "Active",
                    inactive: "Inactive",
                    infoTitle: "Menu association",
                    infoText: "Select a menu from the sidebar and toggle its submenus for the role.",
                    menuListTitle: "Menus",
                    selectMenuHint: "Select a menu"
                }
            }
        }
    },
    methods: {
        nameRol() {
            if (this.IdRol && this.IdRol != "") { 
                Roles.getAllRolesById(this.IdRol) 
                    .then((res) => { 
                        this.nombreRol = res.data.rolById[0]?.nombre || "" 
                    })
                    .catch((error) => { 
                        console.log(error) 
                    }) 
            }
        },
        listaSubmenu(idMenu) {
            if (!this.IdRol) {
                console.error('IdRol está vacío o es undefined');
                this.$toast.error('No se pudo obtener el ID del rol');
                return;
            }
            
            if (!idMenu) {
                console.error('idMenu está vacío o es undefined');
                return;
            }

            const idRolNumerico = Number(this.IdRol);
            const idMenuNumerico = Number(idMenu);
            
            console.log('Llamando a getSubMenuByRolByMenu con:', { 
                idRol: idRolNumerico, 
                idMenu: idMenuNumerico,
                idRolOriginal: this.IdRol,
                idMenuOriginal: idMenu
            });
            
            this.selectedMenuId = idMenu;
            this.menuSelected = idMenu;
            
            Submenu.subMenuByIdMenu(idMenuNumerico)
                .then((res) => {
                    this.listadoSubMenus = res.data.listSubMenu || [];
                    this.showRow = this.listadoSubMenus.length === 0;
                })
                .catch((error) => {
                    console.log('Error en subMenuByIdMenu:', error);
                });

            RoleMenu.getSubMenuByRolByMenu(idRolNumerico, idMenuNumerico)
                .then((res) => {
                    console.log('Respuesta de getSubMenuByRolByMenu:', res.data);
                    let submenuChecked = [];
                    this.listadoSubMenusAsoc = res.data.listRolMenu || [];
                    this.listadoSubMenusAsoc.forEach((elem) => {
                        submenuChecked.push(elem.id_submenu);
                    });
                    this.submenuSelect = submenuChecked;
                })
                .catch((error) => {
                    console.error('Error en getSubMenuByRolByMenu:', error);
                    console.error('Detalles del error:', error.response?.data || error.message);
                    this.$toast.error('Error al cargar los submenús asociados');
                });

            this.nombreMenu = this.listadoMenus.find((lm) => lm.id == idMenu);
        },
        asociaSubMenu(subMenuId) {
            if (!this.IdRol || !this.menuSelected || !subMenuId) {
                this.$toast.error('Faltan datos para asociar el submenú');
                return;
            }

            let datos = {
                idRol: Number(this.IdRol),
                idMenu: Number(this.menuSelected),
                idSubmenu: Number(subMenuId)
            };

            console.log('Enviando datos para asociar:', datos);

            RoleMenu.updateAsociacionRolemenu(datos) 
                .then((res) => { 
                    this.$toast.success(res.data.message || 'Submenú asociado correctamente'); 
                })
                .catch((err) => { 
                    console.error('Error al asociar submenú:', err);
                    this.$toast.error('Error al asociar el submenú');
                }) 
        },
        cierraModal() {
            this.listadoSubMenus = [] 
            this.submenuSelect = []
            this.selectedMenuId = null
            this.menuSelected = ""
            this.nombreMenu = "" 
            this.showRow = false
            this.$emit('closeModal', false) 
        }
    },
    watch: {
        IdRol: {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    this.nameRol()
                }
            }
        },
        modAsociaMenu: {
            handler(newVal) {
                if (newVal && this.IdRol && this.listadoMenus.length > 0 && !this.selectedMenuId) {
                    this.listaSubmenu(this.listadoMenus[0].id)
                }
            }
        }
    },
    mounted() {
        Menu.getAllMenu() 
            .then((res) => { 
                this.listadoMenus = res.data.listMenu || [] 
                if (this.modAsociaMenu && this.IdRol && this.listadoMenus.length > 0) {
                    this.listaSubmenu(this.listadoMenus[0].id)
                }
            })
            .catch((error) => { 
                console.log(error) 
            }) 
    }
}
</script>